import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/pages/Main';
import Login from '@/pages/Login';
import Users from '@/pages/Users';
import Questionnaires from '@/pages/Questionnaires';
import Profile from '@/pages/Profile';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: Login,
    },
    {
      path: '/',
      name: 'MainPage',
      component: Main,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'ProfilePage',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'UsersPage',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/questionnaires',
      name: 'QuestionnairesPage',
      component: Questionnaires,
      meta: {
        requiresAuth: true
      }
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['security/isLoggedIn']) {
      next({ name: 'LoginPage' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router;
